import { createAction, handleActions } from 'redux-actions';
import * as R from 'ramda';

export const pages = {
  list: 'LIST',
  form: 'FORM',
};

export const types = {
  ballsListLoad: 'BALL_LIST_LOAD',
  ballsListLoaded: 'BALL_LIST_LOADED',
  ballHandleForm: 'BALL_HANDLE_FORM',
  ballSetPhoto: 'BALL_SET_PHOTO',
  ballSet: 'BALL_SET',
  ballError: 'BALL_ERROR',
  ballSaved: 'BALL_SAVED',
  ballChangeState: 'BALL_CHANGE_STATE',
  ballsChangePage: 'BALLS_CHANGE_PAGE',
  ballsChangeOrder: 'BALLS_CHANGE_ORDER',
  ballSelect: 'BALL_SELECT',
  ballAddNew: 'BALL_ADD_NEW',
  ballRemove: 'BALL_REMOVE',
  ballTakePhoto: 'BALL_TAKE_PHOTO',
  ballGalleryPhoto: 'BALL_GALLERY_PHOTO',
  ballRemovePhoto: 'BALL_REMOVE_PHOTO',
  ballSavePhoto: 'BALL_SAVE_PHOTO',
  ballPhotoSaved: 'BALL_PHOTO_SAVED',
};

export const ballsListLoad = createAction(types.ballsListLoad);

export const ballsListLoaded = createAction(types.ballsListLoaded);

export const ballHandleForm = createAction(types.ballHandleForm);

export const ballSet = createAction(types.ballSet);

export const ballSetPhoto = createAction(types.ballSetPhoto);

export const ballSelect = createAction(types.ballSelect);

export const ballError = createAction(types.ballError);

export const ballSaved = createAction(types.ballSaved);

export const ballsChangePage = createAction(types.ballsChangePage);

export const ballAddNew = createAction(types.ballAddNew);

export const ballRemove = createAction(types.ballRemove);

export const ballTakePhoto = createAction(types.ballTakePhoto);

export const ballGalleryPhoto = createAction(types.ballGalleryPhoto);

export const ballRemovePhoto = createAction(types.ballRemovePhoto);

export const ballSavePhoto = createAction(types.ballSavePhoto);

export const ballPhotoSaved = createAction(types.ballPhotoSaved);

export const ballChangeState = createAction(types.ballChangeState);

export const ballsChangeOrder = createAction(types.ballsChangeOrder);

export const INITIAL_STATE = {
  loading: false,
  saving: false,
  balls: [],
  currentPage: pages.list,
  error: null,
  ball: {},
};

export const arsenalReducer = handleActions(
  {
    [types.ballsListLoad]: state => ({
      ...state,
      loading: true,
    }),
    [types.ballsListLoaded]: (state, action) => ({
      ...state,
      balls: [...action.payload.balls],
      ball: action.payload.selectFirst ? { ...action.payload.balls[0] } : state.ball,
      currentPage: action.payload.selectFirst ? pages.list : state.currentPage,
      loading: false,
    }),
    [types.ballHandleForm]: state => ({
      ...state,
      saving: true,
    }),
    [types.ballSet]: (state, action) => ({
      ...state,
      ball: R.merge(state.ball)(action.payload.ball),
    }),
    [types.ballSelect]: (state, action) => ({
      ...state,
      ball: action.payload.ball ? { ...action.payload.ball } : null,
      currentPage: action.payload.noChangePage ? state.currentPage : pages.form,
    }),
    [types.ballSaved]: state => ({
      ...state,
      saving: false,
    }),
    [types.ballError]: (state, action) => ({
      ...state,
      error: action.payload.error,
      saving: false,
    }),
    [types.ballsChangePage]: (state, action) => ({
      ...state,
      currentPage: action.payload.page,
    }),
    [types.ballPhotoSaved]: (state, action) => ({
      ...state,
      ball: { ...state.ball, photo: action.payload.photo },
    }),
    [types.ballRemovePhoto]: state => ({
      ...state,
      ball: { ...state.ball, photo: null },
    }),
    [types.ballRemove]: (state, action) => ({
      ...state,
      balls: state.balls.filter(ball => ball.id !== action.payload.ball.id),
    }),
    [types.ballChangeState]: (state, action) => ({
      ...state,
      balls: R.update(R.findIndex(R.propEq('id', action.payload.ball.id))(state.balls))({
        ...action.payload.ball,
        enable: action.payload.state,
      })(state.balls),
    }),
    [types.ballsChangeOrder]: (state, { payload: { oldIndex, newIndex } }) => ({
      ...state,
      balls: R.move(oldIndex, newIndex, state.balls),
    }),
  },
  INITIAL_STATE
);
